import request from '../utils/request'

export function getDict(dictName) {
  const params = {
    dictName,
    page: 0,
    size: 9999
  }
  return request({
    url: 'api/dictDetail/get',
    method: 'get',
    params
  })
}

export function getAllList(selectYear) {
  const params = {
    selectYear
  }
  return request({
    url: 'api/app/getall',
    method: 'get',
    params
  })
}

export function getTypeProjects(i, selectYear) {
  const params = {
    i,
    selectYear
  }
  return request({
    url: 'api/app/gettypeall',
    method: 'get',
    params
  })
}

export function getTotalProjectsDetail(id) {
  return request({
    url: 'api/app/gettotaldetail?id=' + id,
    method: 'get'
  })
}

export function getProjectListByZt(type, selectYear) {
  const params = {
    type,
    selectYear
  }
  return request({
    url: `api/app/gettotallist`,
    method: 'get',
    params
  })
}

export function getProjectDetail(id) {
  return request({
    url: 'api/app/getdetail?id=' + id,
    method: 'get'
  })
}

export function psMethod(data) {
  return request({
    url: 'api/app/ps',
    method: 'post',
    data
  })
}

export function getPs(id) {
  return request({
    url: 'api/app/getps?id=' + id,
    method: 'get'
  })
}

export function getMrzx() {
  return request({
    url: 'api/app/getmrzx',
    method: 'get'
  })
}

export function getLbxm(selectYear) {
  const params = {
    selectYear
  }
  return request({
    url: 'api/app/lbxm',
    method: 'get',
    params
  })
}

export function getZhxm(selectYear) {
  const params = {
    year: selectYear
  }
  return request({
    url: '/magic-api/jsc/zhxm/get',
    method: 'get',
    params
  })
}

export function getAllScore(selectYear) {
  const params = {
    selectYear
  }
  return request({
    url: 'api/app/getallscore',
    method: 'get',
    params
  })
}

export function getAllScoreNew() {
  return request({
    url: 'api/app/getallscorenew',
    method: 'get'
  })
}

export function focusMethod(id) {
  return request({
    url: 'api/app/focus?id=' + id,
    method: 'get'
  })
}

export function cancelFocus(id) {
  return request({
    url: 'api/app/cancelfocus?id=' + id,
    method: 'get'
  })
}

export function getMyproject(id) {
  return request({
    url: 'api/app/myproject',
    method: 'get'
  })
}

export function getMyFocus(id) {
  return request({
    url: 'api/app/myfocus',
    method: 'get'
  })
}

export function getMyps(id) {
  return request({
    url: 'api/app/myps',
    method: 'get'
  })
}

export function getXxkd() {
  return request({
    url: 'api/app/getxxkd',
    method: 'get'
  })
}

export function gethotNews() {
  return request({
    url: 'api/app/gethotnews',
    method: 'get'
  })
}

/**
 * 登录接口
 */
export function login(data) {
  return request({
    url: 'auth/jsc/login',
    method: 'post',
    data
  })
}

/**
 * 稳进提质数据
 */
export function getWjtz() {
  return request({
    url: '/magic-api/jsc/get/home5Data',
    method: 'get'
  })
}

/**
 *  支撑指标和街道所有数据
 */
export function getJjzb1() {
  return request({
    url: '/magic-api/jsc/get/home2Data',
    method: 'get'
  })
}

/**
 *  主要经济指标所有数据
 */
export function getJjzb2() {
  return request({
    url: '/magic-api/jsc/get/home3Data',
    method: 'get'
  })
}

/**
 * app 专属经济指标数据
 */
export function getJjzb(selectYear) {
  const params = {
    selectYear
  }
  return request({
    url: '/magic-api/jsc/get/jjdb',
    method: 'get',
    params
  })
}
/**
 * 考核得分
 */
export function ApiGetmonthscorelist(params) {
  return request({
    url: '/api/deptscore/getmonthscorelist',
    method: 'get',
    params
  })
}

/**
 * 获取详细列表
 */
export function DetailListEeplace(data) {
  return request({
    url: '/magic-api/jsc/projectDetail',
    method: 'post',
    data
  })
}
/**
 * 获取所有背景图片
 */
export function ApiGetAllImg(params) {
  return request({
    url: '/magic-api/img/getAll',
    method: 'get',
    params
  })
}

export default {
  DetailListEeplace,
  getAllList,
  getTypeProjects,
  getTotalProjectsDetail,
  getProjectDetail,
  getProjectListByZt,
  psMethod,
  getPs,
  getMrzx,
  getLbxm,
  getZhxm,
  getAllScore,
  focusMethod,
  cancelFocus,
  getMyproject,
  getMyFocus,
  getMyps,
  getXxkd,
  gethotNews,
  getAllScoreNew,
  ApiGetmonthscorelist,
  ApiGetAllImg
}



// WEBPACK FOOTER //
// ./src/api/zdqd.js